module.exports = __webpack_public_path__ + "static/media/kyle.36b64a49.jpg";